var _path, _g, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTeamMembers = function SvgTeamMembers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "team-members_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.773 10.09c0-3.26 0-4.889.634-6.133a5.818 5.818 0 0 1 2.542-2.543C5.194.78 6.823.78 10.082.78h3.821c3.259 0 4.888 0 6.133.634a5.818 5.818 0 0 1 2.542 2.543c.634 1.244.634 2.874.634 6.132v3.822c0 3.258 0 4.888-.634 6.132a5.818 5.818 0 0 1-2.542 2.543c-1.245.634-2.874.634-6.133.634h-3.821c-3.259 0-4.888 0-6.133-.634a5.818 5.818 0 0 1-2.542-2.543C.773 18.8.773 17.17.773 13.911v-3.822Z",
    fill: "url(#team-members_svg__a)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#team-members_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.772 10.09c0-3.26 0-4.889.635-6.133a5.818 5.818 0 0 1 2.542-2.543C5.194.78 6.823.78 10.082.78h3.821c3.259 0 4.888 0 6.133.634a5.818 5.818 0 0 1 2.542 2.543c.634 1.244.634 2.874.634 6.132v3.822c0 3.258 0 4.888-.634 6.132a5.818 5.818 0 0 1-2.542 2.543c-1.245.634-2.874.634-6.133.634h-3.821c-3.259 0-4.888 0-6.133-.634a5.819 5.819 0 0 1-2.542-2.543C.772 18.8.772 17.17.772 13.911v-3.822Z",
    fill: "url(#team-members_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.772 10.09c0-3.26 0-4.889.635-6.133a5.818 5.818 0 0 1 2.542-2.543C5.194.78 6.823.78 10.082.78h3.821c3.259 0 4.888 0 6.133.634a5.818 5.818 0 0 1 2.542 2.543c.634 1.244.634 2.874.634 6.132v3.822c0 3.258 0 4.888-.634 6.132a5.818 5.818 0 0 1-2.542 2.543c-1.245.634-2.874.634-6.133.634h-3.821c-3.259 0-4.888 0-6.133-.634a5.819 5.819 0 0 1-2.542-2.543C.772 18.8.772 17.17.772 13.911v-3.822Z",
    fill: "url(#team-members_svg__d)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.305a5.695 5.695 0 0 0-4.665 8.963C8.558 14.131 10.262 13.57 12 13.57s3.442.56 4.665 1.698A5.695 5.695 0 0 0 12 6.305Zm3.65 10.068c-.898-.837-2.207-1.303-3.65-1.303s-2.752.466-3.65 1.303A5.672 5.672 0 0 0 12 17.695a5.672 5.672 0 0 0 3.65-1.322ZM4.804 12a7.195 7.195 0 1 1 14.39 0 7.195 7.195 0 0 1-14.39 0ZM12 8.883a1.055 1.055 0 1 0 0 2.11 1.055 1.055 0 0 0 0-2.11ZM9.445 9.938a2.555 2.555 0 1 1 5.11 0 2.555 2.555 0 0 1-5.11 0Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "team-members_svg__a",
    x1: 0.773,
    y1: 0.78,
    x2: 23.212,
    y2: 23.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D72A2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "team-members_svg__c",
    x1: 0.772,
    y1: 0.78,
    x2: 23.212,
    y2: 23.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "team-members_svg__d",
    x1: 0.772,
    y1: 0.78,
    x2: 23.212,
    y2: 23.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5764F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A339A"
  })))));
};

export default SvgTeamMembers;